<script setup lang="ts">
import { inject, ref, useTemplateRef, watch } from 'vue';
import { NxButton } from './../Button';
import { NxTextInput } from './../Inputs';
import DropdownArea from './DropdownArea.vue';
import { i18nInjectionKey } from './../internal';

const emit = defineEmits<{ 'add-link': [link: string]; close: [] }>();
const link = ref<string>('');
const inputRef = useTemplateRef('input-ref');
const i18nInjection = inject(i18nInjectionKey)!;

watch(inputRef, () => {
  inputRef.value?.inputElement?.focus();
});
</script>

<template>
  <DropdownArea
    @close="
      () => {
        link = '';
        emit('close');
      }
    "
  >
    <template #default>
      <slot></slot>
    </template>
    <template #area="{ close }">
      <div class="area">
        <NxTextInput
          ref="input-ref"
          v-model="link"
          placeholder="https://www.blp.de"
          @keydown="
            (e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                emit('add-link', link);
                close();
              }
            }
          "
        />
        <NxButton
          width="full"
          @click="
            () => {
              emit('add-link', link);
              close();
            }
          "
        >
          {{ i18nInjection.t('common.editor.add_link') }}
        </NxButton>
      </div>
    </template>
  </DropdownArea>
</template>

<style scoped>
.area {
  font-size: var(--nxt-font-size-md);
  display: flex;
  flex-direction: column;
  gap: var(--nxt-space-xs);
  width: 20ch;
}
</style>
